import { Builder } from '@builder.io/react';
import theme from '../../utilities/brandTheme';
import EmailSignup from './emailSignup';

Builder.registerComponent(EmailSignup, {
  name: 'EmailSignup',
  inputs: [
    {
      name: 'buttonText',
      type: 'string',
      required: true,
      defaultValue: 'Shop now',
      friendlyName: 'Button Text',
    },
    {
      name: 'buttonVariant',
      type: 'string',
      required: true,
      enum: [...Object.keys(theme.buttons)],
      defaultValue: 'primary',
      friendlyName: 'Button Style',
    },
    {
      name: 'popupTitle',
      type: 'string',
      required: true,
     defaultValue: 'Join the waitlist',
      friendlyName: 'Popup Title',
    },
    {
      name: 'popupSubtitle',
      type: 'string',
      required: false,
      defaultValue: "Thank you for your interest! We haven't launched yet, but we will hold your spot in line and notify you as soon as we do.",
      friendlyName: 'Popup Subtitle',
    },
    {
      name: 'placeholderText',
      type: 'string',
      required: true,
      defaultValue: 'Enter your email address',
      friendlyName: 'Email Placeholder',
    },
    {
      name: 'popupButtonText',
      type: 'string',
      required: true,
      defaultValue: 'Submit',
      friendlyName: 'Submit Button Text',
    },
    {
      name: 'pageVariant',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Page Variant',
      helperText: 'Leave empty to auto use variant URL',
    },
    {
      name: 'apiEndpoint',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Zapier Endpoint',
      helperText: 'Leave empty to use the brand default',
    },
    {
      name: 'redirectUrl',
      type: 'string',
      required: false,
      defaultValue: '',
      friendlyName: 'Redirect URL (after subscribe)',
    },
  ],
});
